import { Text, StyleSheet } from 'react-native'
import { AutoPayIcon } from '@/src/assets/icons/AutoPayIcon'
import { mesaColorNames } from '@/src/common/theme'
import { formatToDayWithSuffix } from '@/src/common/utils/date'
import { CardPaymentsRoutes } from '@/src/experiences/card-payments/navigation/routes'
import {
  ScheduledPaymentEntryPoint,
  styles as scheduledPaymentEntryPointStyles,
} from '@/src/experiences/card-payments/components/ScheduledPaymentEntryPoint'
import * as CardPaymentsConstants from '@/src/experiences/card-payments/constants'
import * as CardActivity from '@/src/experiences/card-activity'
import { useLoggedInQuery } from '@/src/common/gql/MesaGql'
import { CardPaymentsGqlQueries } from '@/src/experiences/card-payments/gql/queries'
import type { PaymentCardStackScreenProps } from '@/src/experiences/card-payments/screens/MakePayment'

export function useLegacyAutoPayEntryPoint({ CardStackLink }: PaymentCardStackScreenProps) {
  const { data: recurringScheduledPayment, loading: loadingRecurringScheduledPayment } =
    useLoggedInQuery(CardPaymentsGqlQueries.GET_RECURRING_SCHEDULED_PAYMENTS, {
      fetchPolicy: 'cache-and-network',
    })

  if (loadingRecurringScheduledPayment) return 'loading'

  const paymentSchedule = recurringScheduledPayment?.getRecurringScheduledPayment
  const isAutoPayEnabled =
    paymentSchedule &&
    (paymentSchedule.transferAmountStrategy || paymentSchedule.nextScheduledTransferDate)

  return (
    <CardStackLink
      href={
        isAutoPayEnabled
          ? CardPaymentsRoutes.CardManagementAutoPayReview.route
          : CardPaymentsRoutes.CardManagementAutoPay.route
      }
      testID={CardPaymentsConstants.Ids.Press.ScheduleAutoPay}
      asChild
    >
      <ScheduledPaymentEntryPoint
        Icon={AutoPayIcon}
        style={{ paddingLeft: 16, paddingRight: 16, paddingTop: 16, paddingBottom: 16 }}
      >
        {paymentSchedule?.transferAmountStrategy || paymentSchedule?.nextScheduledTransferDate ? (
          <Text style={scheduledPaymentEntryPointStyles.title}>
            Auto-pay scheduled
            {paymentSchedule.transferAmountStrategy
              ? ` for ${CardActivity.Components.Highnote.ScheduledTransfers.calculatedTypeText[paymentSchedule.transferAmountStrategy]}`
              : ''}
            {paymentSchedule.nextScheduledTransferDate
              ? ` on the ${formatToDayWithSuffix(new Date(paymentSchedule.nextScheduledTransferDate))} of the month`
              : ''}
          </Text>
        ) : (
          <Text style={[scheduledPaymentEntryPointStyles.title, styles.disabled]}>
            {CardPaymentsConstants.Strings.AutoPayOff}
          </Text>
        )}
      </ScheduledPaymentEntryPoint>
    </CardStackLink>
  )
}

const styles = StyleSheet.create({
  disabled: { color: mesaColorNames['Greyscale/500 #6E7375'] },
})
